import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateFax = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 496.75 496.92",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.1;}.d{fill:#fafcff;}.e{fill:#9ec5ff;}.f{fill:#b5c5ea;}.g{fill:#dcebfe;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 249.95,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "c",
					d: "M463.13,170.55H144.45v-3.18c0-10.89-8.83-19.72-19.72-19.72H54.13c-10.89,0-19.72,8.83-19.72,19.72V443.26c0,10.89,8.83,19.72,19.72,19.72H124.72c9.83,0,17.96-7.21,19.46-16.62H463.13c11.05,0,20-8.95,20-20V190.55c0-11.05-8.95-20-20-20Z"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "g",
					x: 42.84,
					y: 159.43,
					width: 431.46,
					height: 275.81,
					rx: 20,
					ry: 20
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 25.59,
					y: 136.52,
					width: 110.04,
					height: 315.33,
					rx: 19.72,
					ry: 19.72
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 190.65,
						cy: 266.2,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 261.77,
						cy: 266.2,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 332.88,
						cy: 266.2,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 190.65,
						cy: 325.97,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 261.77,
						cy: 325.97,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 332.88,
						cy: 325.97,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 190.65,
						cy: 385.74,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 261.77,
						cy: 385.74,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 332.88,
						cy: 385.74,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 404,
						cy: 266.2,
						r: 20.18
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 383.82,
						y: 305.78,
						width: 40.37,
						height: 100.14,
						rx: 20.18,
						ry: 20.18
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 168.22,
						y: 105.63,
						width: 258.21,
						height: 115.08,
						rx: 8.71,
						ry: 8.71
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "d",
						x: 194.66,
						y: 124.64,
						width: 205.33,
						height: 77.07,
						rx: 3.85,
						ry: 3.85
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M247.74,169.63c-.8-1.78-.86-4.07-.86-6.98s.06-5.2,.86-6.98c1.07-2.39,3.34-4.04,6.64-4.04s5.57,1.65,6.64,4.04c.8,1.78,.86,4.07,.86,6.98s-.06,5.2-.86,6.98c-1.07,2.39-3.34,4.04-6.64,4.04s-5.57-1.65-6.64-4.04Zm9.34-1.71c.4-.89,.43-3.31,.43-5.27s-.03-4.38-.43-5.27c-.43-.95-1.32-1.44-2.69-1.44s-2.27,.49-2.69,1.44c-.4,.89-.43,3.31-.43,5.27s.03,4.38,.43,5.27c.43,.95,1.32,1.44,2.69,1.44s2.27-.49,2.69-1.44Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M266.01,173.37c-.34,0-.61-.28-.61-.61v-20.2c0-.34,.28-.61,.61-.61h10.71c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-6.73c-.18,0-.31,.12-.31,.31v3.67c0,.18,.12,.31,.31,.31h6.43c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-6.43c-.18,0-.31,.12-.31,.31v7.65c0,.34-.28,.61-.61,.61h-3.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M280.71,173.37c-.34,0-.61-.28-.61-.61v-20.2c0-.34,.28-.61,.61-.61h10.71c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-6.73c-.18,0-.31,.12-.31,.31v3.67c0,.18,.12,.31,.31,.31h6.43c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-6.43c-.18,0-.31,.12-.31,.31v7.65c0,.34-.28,.61-.61,.61h-3.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M295.4,173.37c-.34,0-.61-.28-.61-.61v-20.2c0-.34,.28-.61,.61-.61h3.06c.34,0,.61,.28,.61,.61v16.22c0,.18,.12,.31,.31,.31h6.43c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-10.41Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M309.48,173.37c-.34,0-.61-.28-.61-.61v-20.2c0-.34,.28-.61,.61-.61h3.06c.34,0,.61,.28,.61,.61v20.2c0,.34-.28,.61-.61,.61h-3.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M318.05,173.37c-.34,0-.61-.28-.61-.61v-20.2c0-.34,.28-.61,.61-.61h3.64c.46,0,.67,.28,.77,.55l4.19,12.55c.06,.18,.28,.12,.28-.06v-12.43c0-.34,.28-.61,.61-.61h3.06c.34,0,.61,.28,.61,.61v20.2c0,.34-.28,.61-.61,.61h-3.61c-.52,0-.73-.28-.83-.52l-4.16-11.66c-.06-.18-.28-.12-.28,.06v11.51c0,.34-.28,.61-.61,.61h-3.06Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M336.12,173.37c-.34,0-.61-.28-.61-.61v-20.2c0-.34,.28-.61,.61-.61h11.11c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-7.13c-.18,0-.31,.12-.31,.31v3.67c0,.18,.12,.31,.31,.31h6.89c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-6.89c-.18,0-.31,.12-.31,.31v3.67c0,.18,.12,.31,.31,.31h7.25c.34,0,.61,.28,.61,.61v3.06c0,.34-.28,.61-.61,.61h-11.23Z"
						})
					] })
				] })
			] })
		})
	]
});
export default SvgEmptyStateFax;
